export const BASES_ENDPOINT = 'winter-service-bases'

// Every base a record may be attached to. Each row carries the subcontractors stationed
// at that base and their operators, so a screen that picks a base gets both for free -
// see the vehicle's winter service tab.
export const BASES_AUTOCOMPLETE_ENDPOINT = `${BASES_ENDPOINT}/autocomplete`

// The photo has endpoints of its own - it is never part of the base's own
// payload, so it is uploaded (and cleared) separately after the record exists.
export const buildBasePhotoEndpoint = (baseId) => `${BASES_ENDPOINT}/${baseId}/photo`

export const BASES_TABLE_KEY = 'winter-service-v2-bases'
export const BASES_UI_VIEW = 'winter_service2_bases'

export const BASES_INDEX_ROUTE = 'WinterService2Bases'
export const BASE_DETAILS_ROUTE = 'WinterService2BaseDetails'

export const BASES_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/bases'

// The base's photo is picked as a File on this key. It has no form field of its
// own (the image panel owns it) and no place in the save payload either - see
// `baseData` for how it reaches its own endpoint.
export const BASE_PHOTO_KEY = 'photo'
